import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export function usePushNotifications() {
  const { user } = useAuth();
  const subscribedRef = useRef(false);

  useEffect(() => {
    if (!user || subscribedRef.current) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    const subscribe = async () => {
      try {
        // Get VAPID key
        const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
        if (!vapidKey) return;

        // Wait for service worker
        const reg = await navigator.serviceWorker.ready;

        // Check existing subscription
        let sub = await reg.pushManager.getSubscription();
        if (!sub) {
          // Request permission
          const perm = await Notification.requestPermission();
          if (perm !== 'granted') return;

          // Subscribe
          sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapidKey),
          });
        }

        // Send subscription to backend
        const subJson = sub.toJSON();
        await api.post('/push-subscription', {
          endpoint: subJson.endpoint,
          keys: subJson.keys,
        });

        subscribedRef.current = true;
      } catch (err) {
        // Silent — push not critical
        console.warn('Push subscription failed:', err.message);
      }
    };

    // Delay slightly to not block initial render
    const timer = setTimeout(subscribe, 3000);
    return () => clearTimeout(timer);
  }, [user]);
}
